// extracted by mini-css-extract-plugin
module.exports = {"container":"_vp_89EEV","mobileBanner":"_OBEHoXpl","header":"_fvRFsp-L","title":"_XQaz_QmW","badge":"__VD-yWrK"};